import { ErrorCodes, Labels } from '../enums';
import type { ErrorDetails } from '../types';

export const BEACON_ERRORS: Record<string, ErrorDetails> = {
    401: {
        key: 'UNAUTHORIZED',
        title: Labels.ERROR_ACCESSING_VIDEO,
        message: Labels.YOURE_NOT_ALLOWED_VIDEO_FORBIDDEN,
        code: ErrorCodes.UNAUTHORIZED
    },
    403: {
        key: 'FORBIDDEN',
        title: Labels.EVENT_NOT_AVAILABLE_IN_TERRITORY,
        message: Labels.YOURE_NOT_ALLOWED_VIDEO_FORBIDDEN,
        code: ErrorCodes.FORBIDDEN
    },
    409: {
        key: 'CONFLICT',
        title: Labels.WATCHING_VIDEO_ON_ANOTHER_DEVICE,
        message: Labels.TO_WATCH_HERE_CLOSE_OTHER_SESSIONS,
        code: ErrorCodes.CONFLICT
    },
    default: {
        key: 'VIDEO_ERROR',
        title: Labels.ERROR_ACCESSING_VIDEO,
        message: Labels.PLEASE_TRY_AGAIN_VIDEO_ERROR,
        code: ErrorCodes.VIDEO_ERROR
    }
};
